module.exports = __webpack_public_path__ + "img/public/SiteIcons/zipCodeIcon.svg?cc9e7408";